import {
  AnchorHTMLAttributes,
  ButtonHTMLAttributes,
  ElementType,
  ReactNode,
} from 'react';
import * as S from './styles';

type ButtonTypes =
  | AnchorHTMLAttributes<HTMLAnchorElement>
  | ButtonHTMLAttributes<HTMLButtonElement>;

export type ButtonProps = {
  children?: string | ReactNode;
  variant?:
  | 'primary'
  | 'secondary'
  | 'success'
  | 'minimal'
  | 'anchor'
  | 'brandPrimary'
  | 'text'
  | 'invert';
  fullWidth?: boolean;
  styleVariant?: 'filled' | 'outline';
  icon?: JSX.Element | React.ReactNode;
  iconPosition?: 'right' | 'left';
  as?: 'a' | 'button' | ElementType<any>;
  size?: 'small' | 'medium' | 'default';
  status?: 'info' | 'success';
} & ButtonTypes;

const Button = ({
  children,
  variant = 'primary',
  fullWidth = false,
  icon,
  iconPosition = 'left',
  as = 'button',
  size = 'default',
  status,
  styleVariant = 'outline',
  ...props
}: ButtonProps) => (
  <S.Wrapper
    variant={variant}
    styleVariant={styleVariant}
    fullWidth={fullWidth}
    hasIcon={!!icon}
    size={size}
    iconPosition={iconPosition}
    {...props}
    as={as}
    status={status}
  >
    {!!icon && icon}
    {!!children && <span>{children}</span>}
  </S.Wrapper>
);

export default Button;
